import SockJS from 'sockjs-client';
import Stomp, { Frame } from 'stompjs';
import {
  updateOddsfromWS,
  updateSecondaryMarkets,
  updateSecondaryMatchOdds,
  updateGameData,
  updateGameResults,
  updateEventScorecard,
} from '../store';
import store from '../store/store';
import { getBaseUrl } from '../api-services/environment-url/environment-url';
import { setBetFairWSConnection, setDreamWSConnection, triggerFetchMarkets, triggerFetchOrders, updateBinaryMarkets, updateCommissionMarkets, updateFancyMarkets, updateSuspendedMarkets } from '../store/exchangeSports/exchangeSportsActions';
import moment from 'moment';
import { getSapTokenFromToken } from '../store/auth/authActions';
import { triggerFetchBalance, triggerFetchNotifications } from '../store/common/commonActions';
import { NotificationType } from '../models/NotificationType';

let stompClient: Stomp.Client = null;
let dreamClient: Stomp.Client = null;

let bfLastMsgTime = null;
let dreamLastMsgTime = null;

// Match Odds Subscriptions
let wsSubscriptions = {};
let eventHierarchyMap: Map<string, string> = new Map();

// Bookmaker & Fancy Subscriptions
let wsSecMarketSubscritions = {};

// Secondary Match Odds Subscriptions
let wsSecMatchOddsSubscritions = {};

// Indian Casino Subscriptions
let wsInCasinoSubscriptions = {};

// Scorecard Subscriptions
let wsScorecardSubscriptions = {};

let wsFancyMarketSubscritions = {};

let pushNotClient: Stomp.Client = null;
let pnLastMsgTime = null;
let wsPushNotSubscriptions = {};

// Binary Subscriptions
let wsSecBinarySubscrition;
let refreshBetFairInterval: NodeJS.Timeout | undefined;
let refreshDreamInterval: NodeJS.Timeout | undefined;

// Check WS connection.
export const isConnected = () => stompClient && stompClient.connected;

// Exchange Events.

export const connectToWS = (baseUrlsPayload: any) => {
  // connectToBFWS(baseUrlsPayload?.matchOddsBaseUrl);
  connectToBFWS(baseUrlsPayload?.matchOddsBaseUrl);
  connectToDreamWS(baseUrlsPayload?.bookMakerAndFancyBaseUrl);
};

export const isPushNotificationConnected = () =>
  pushNotClient && pushNotClient.connected;

export const connectToPushNotification = () => {
  if (pushNotClient == null) {
    const baseUrl = getBaseUrl(
      process.env.REACT_APP_NODE_ENV,
      'REACT_APP_WEBSOCKET_URL_PUSH_NOTIFICATIONS'
    );
    const socket = new SockJS(baseUrl);
    pushNotClient = Stomp.over(socket);
    pushNotClient.heartbeat.outgoing = 5000;
    pushNotClient.connect(
      {},
      function (frame) {
        console.log('PN Connected: ' + frame + ' time ' + moment.now());
      },
      function (error: Frame | string) {
        console.log('pn ws_error: ' + error + ' time ' + moment.now());
        pushNotClient = null;
      }
    );
    pnLastMsgTime = moment.now();
  }
};

export const checkPNStompClientSubscriptions = () => {
  if (!(pushNotClient && pushNotClient.connected)) {
    connectToPushNotification();
  }
  if (moment.now() - pnLastMsgTime > 300000) {
    console.log(
      'PN last message is > 300000' + (moment.now() - pnLastMsgTime) + 'ms'
    );
    disConnectToPushNotificationWS();
    // Getting balance when websocket is geeting disconnected
    store.dispatch(triggerFetchBalance(moment.now()));
    connectToPushNotification();
  }
};

export const subscribeWsForNotifications = (
  isMultiMarket: boolean,
  houseId: string,
  sportId?: string,
  competitionId?: string,
  eventId?: string
) => {
  if (pushNotClient !== null && pushNotClient.connected) {
    if (wsPushNotSubscriptions[houseId] === undefined) {
      wsPushNotSubscriptions[houseId] = pushNotClient.subscribe(
        `/topic/notifications/${houseId}`,
        function (message) {
          try {
            const notification = JSON.parse(message.body);
            switch (notification.notification_type) {
              case NotificationType.MARKET_SUSPENDED: {
                if (
                  notification.data?.eventId &&
                  eventId === notification.data.eventId
                ) {
                  store.dispatch(updateSuspendedMarkets(notification.data));
                }
                break;
              }
              case NotificationType.MARKET_COMMISSION_ENABLED: {
                if (
                  notification.data?.eventId &&
                  eventId === notification.data.eventId
                ) {
                  store.dispatch(updateCommissionMarkets(notification.data));
                }
                break;
              }
              case NotificationType.ORDER_LIMIT_UPDATED: {
                store.dispatch(
                  triggerFetchMarkets(
                    sportId,
                    competitionId,
                    eventId,
                    notification.data
                  )
                );
                break;
              }
              case NotificationType.NOTIFICATION_UPDATED: {
                store.dispatch(triggerFetchNotifications(notification.data));
                break;
              }
              default:
                console.log(
                  'Invalid notification type: ',
                  notification.notification_type
                );
            }
            pnLastMsgTime = moment.now();
          } catch (ex) {
            console.error('Failed to update suspend market details ', ex);
          }
        }
      );
    }
  } else {
    // TODO: is this required ?
    setTimeout(
      () =>
        subscribeWsForNotifications(
          isMultiMarket,
          houseId,
          sportId,
          competitionId,
          eventId
        ),
      1000
    );
  }
};

export const subscribeWsForNotificationsPerAdminAllMarkets = (
  isMultiMarket: boolean,
  houseId: string,
  parentId: string,
  accountId: string,
  eventId: string
) => {
  var key = eventId ? parentId + ':' + eventId : parentId;
  if (pushNotClient !== null && pushNotClient.connected) {
    if (wsPushNotSubscriptions[key] === undefined && eventId !== undefined) {
      wsPushNotSubscriptions[key] = pushNotClient.subscribe(
        `/topic/notifications/${houseId}/${parentId}`,
        function (message) {
          try {
            const notification = JSON.parse(message.body);
            if (notification.data.accountId.toString() === accountId) {
              switch (notification.notification_type) {
                case NotificationType.BALANCE_CHANGED: {
                  store.dispatch(triggerFetchBalance(moment.now()));
                  break;
                }
                case NotificationType.ORDER_UPDATED: {
                  if (eventId && eventId === notification?.data?.eventId) {
                    store.dispatch(triggerFetchOrders());
                  }
                  break;
                }
                // case NotificationType.ORDER_PLACED:
                // case NotificationType.ORDER_FAILED: {
                //   if (!isMultiMarket) {
                //     if (eventId && eventId === notification?.data?.eventId) {
                //       store.dispatch(triggerBetStatus());
                //     }
                //   }
                //   break;
                // }
                default:
                  console.log(
                    'Invalid notification type: ',
                    notification.notification_type
                  );
              }
            }
            pnLastMsgTime = moment.now();
          } catch (ex) {
            console.error('Failed process notification ', ex);
          }
        }
      );
    }
  } else {
    setTimeout(
      () =>
        subscribeWsForNotificationsPerAdminAllMarkets(
          isMultiMarket,
          houseId,
          parentId,
          accountId,
          eventId
        ),
      1000
    );
  }
};

export const subscribeWsForNotificationsPerAdmin = (
  isMultiMarket: boolean,
  houseId: string,
  parentId: string,
  accountId: string
) => {
  if (pushNotClient !== null && pushNotClient.connected) {
    if (wsPushNotSubscriptions[parentId] === undefined) {
      wsPushNotSubscriptions[parentId] = pushNotClient.subscribe(
        `/topic/notifications/${houseId}/${parentId}`,
        function (message) {
          try {
            const notification = JSON.parse(message.body);
            if (notification.data.accountId.toString() === accountId) {
              switch (notification.notification_type) {
                case NotificationType.BALANCE_CHANGED: {
                  store.dispatch(triggerFetchBalance(moment.now()));
                  break;
                }
                // case NotificationType.ORDER_UPDATED: {
                //   if (isMultiMarket) {
                //     store.dispatch(
                //       triggerMultiFetchOrders(notification?.data?.eventId)
                //     );
                //   }
                //   break;
                // }
                // case NotificationType.ORDER_PLACED:
                // case NotificationType.ORDER_FAILED: {
                //   if (isMultiMarket) {
                //     store.dispatch(
                //       triggerMultiBetStatus(notification?.data?.eventId)
                //     );
                //   }
                //   break;
                // }
                default:
                  console.log(
                    'Invalid notification type: ',
                    notification.notification_type
                  );
              }
            }
            pnLastMsgTime = moment.now();
          } catch (ex) {
            console.error('Failed process notification ', ex);
          }
        }
      );
    }
  } else {
    setTimeout(
      () =>
        subscribeWsForNotificationsPerAdmin(
          isMultiMarket,
          houseId,
          parentId,
          accountId
        ),
      1000
    );
  }
};

export const disConnectToPushNotificationWS = () => {
  if (pushNotClient != null) {
    for (const houseId of Object.keys(wsPushNotSubscriptions)) {
      wsPushNotSubscriptions[houseId].unsubscribe();
      console.log('pn unsubscribed ' + houseId);
      delete wsPushNotSubscriptions[houseId];
    }

    wsPushNotSubscriptions = {};

    if (pushNotClient.connected) {
      pushNotClient.disconnect(() =>
        console.log('PN Disconnected - time ' + moment.now())
      );
    }
    pushNotClient = null;
  }
};

const connectToDreamWS = (baseUrl: string) => {
  if (dreamClient == null) {
    // Bookmaker & Fancy
    const dreamSocket = new SockJS(baseUrl);
    dreamClient = Stomp.over(dreamSocket);
    dreamClient.debug = null;
    dreamClient.heartbeat.outgoing = 5000;
    dreamClient.connect(
      { token: `Bearer ${getSapTokenFromToken()}` },
      function (frame) {
        console.log('DR Connected: ' + frame + ' time ' + moment.now());
        store.dispatch(setDreamWSConnection(true));
        clearInterval(refreshDreamInterval);
        refreshDreamInterval = undefined;
      },
      function (error: Frame | string) {
        store.dispatch(setDreamWSConnection(false));
        disConnectToDreamWS();
        console.log('dream ws_error: ' + error + ' time ' + moment.now());
        if (typeof refreshDreamInterval === 'undefined') {
          refreshDreamInterval && clearInterval(refreshDreamInterval);
  
          refreshDreamInterval = setInterval(() => {
            connectToDreamWS(baseUrl);
          }, 30 * 1000);
        }
      }
    );
    dreamLastMsgTime = moment.now();
  }
};

const disConnectToDreamWS = () => {
  if (dreamClient != null) {
    for (const wsEvent of Object.keys(wsSecMarketSubscritions)) {
      wsSecMarketSubscritions[wsEvent].unsubscribe();
      console.log('dream unsubscribed ' + wsEvent);
      delete wsSecMarketSubscritions[wsEvent];
    }

    wsSecMarketSubscritions = {};

    for (const wsEvent of Object.keys(wsFancyMarketSubscritions)) {
      wsFancyMarketSubscritions[wsEvent].unsubscribe();
      console.log('dream unsubscribed ' + wsEvent);
      delete wsFancyMarketSubscritions[wsEvent];
    }

    wsFancyMarketSubscritions = {};

    dreamClient.disconnect(() =>
      console.log('Dream Disconnected - time ' + moment.now())
    );
    dreamClient = null;
  }
};

const connectToBFWS = (baseUrl: string) => {
  if (stompClient == null) {
    // Match odds
    const socket = new SockJS(baseUrl);
    stompClient = Stomp.over(socket);
    stompClient.debug = null;
    stompClient.heartbeat.outgoing = 5000;
    stompClient.connect(
      { token: `Bearer ${getSapTokenFromToken()}` },
      function (frame) {
        console.log('BF Connected: ' + frame + ' time ' + moment.now());
        store.dispatch(setBetFairWSConnection(true))
        clearInterval(refreshBetFairInterval);
        refreshBetFairInterval = undefined;
      },
      function (error: Frame | string) {
        store.dispatch(setBetFairWSConnection(false))
        disConnectToBFWS();
        console.log('bf ws_error: ' + error + ' time ' + moment.now());
        if (typeof refreshBetFairInterval === 'undefined') {
          refreshBetFairInterval && clearInterval(refreshBetFairInterval);
  
          refreshBetFairInterval = setInterval(() => {
            connectToBFWS(baseUrl);
          }, 30 * 1000);
        }
      }
    );
    bfLastMsgTime = moment.now();
  }
};

const disConnectToBFWS = () => {
  if (stompClient != null) {
    for (const wsEvent of Object.keys(wsSubscriptions)) {
      wsSubscriptions[wsEvent].unsubscribe();
      console.log('bf unsubscribed ' + wsEvent);
      delete wsSubscriptions[wsEvent];
    }

    for (const wsEvent of Object.keys(wsSecMatchOddsSubscritions)) {
      wsSecMatchOddsSubscritions[wsEvent].unsubscribe();
      console.log('bf unsubscribed ' + wsEvent);
      delete wsSecMatchOddsSubscritions[wsEvent];
    }

    wsSubscriptions = {};
    wsSecMatchOddsSubscritions = {};

    if (store.getState().exchangeSports.betFairWSConnected) {
      stompClient.disconnect(() =>
        console.log('BF Disconnected - time ' + moment.now())
      );
    }
    stompClient = null;
  }
};

export const checkStompClientSubscriptions = (baseUrlsPayload: any) => {
  if (!(store.getState().exchangeSports.betFairWSConnected)) {
    console.log('BetFair client is null or not connected');
    connectToBFWS(baseUrlsPayload.matchOddsBaseUrl);
  }
  if (!(store.getState().exchangeSports.dreamWSConnected)) {
    console.log('Dream client is null or not connected');
    connectToDreamWS(baseUrlsPayload.bookMakerAndFancyBaseUrl);
  }
};

export const subscribeWsForEventOdds = (
  urlTopic: string,
  sportId: string,
  competitionId: string,
  eventId: string,
  marketId: string,
  providerId?: string,
  isMultiMarket?: boolean
) => {
  if (store.getState().exchangeSports.betFairWSConnected) {
    if (wsSubscriptions[eventId + '-' + marketId] === undefined) {
      eventHierarchyMap.set(eventId, `${sportId}-${competitionId}`);
      wsSubscriptions[eventId + '-' + marketId] = stompClient.subscribe(
        `${urlTopic}/${eventId}/${marketId}`,
        function (message) {
          const msgObj = JSON.parse(message.body);
          const msgBody = {
            eventId: msgObj.eventId,
            matchOdds: {
              marketId: msgObj.marketId,
              marketTime: msgObj.marketTime,
              marketName: msgObj.marketName,
              status: msgObj.status,
              runners: msgObj.runners,
            },
          };
          const eventId = msgObj.eventId;
          bfLastMsgTime = moment.now();
          if (eventId) {
            const payload = {
              eventData: msgBody.matchOdds ? msgBody.matchOdds : 'no-data',
              sportId: eventHierarchyMap.get(eventId).split('-')[0],
              competitionId: eventHierarchyMap.get(eventId).split('-')[1],
              eventId: eventId,
              matchOddsData: msgBody.matchOdds ? msgBody.matchOdds : null,
              isMultiMarket: isMultiMarket ? true : false,
            };
            if (payload && payload !== undefined) {
              store.dispatch(updateOddsfromWS(payload));
            }
          }
        }
      );
    }
  } else {
    setTimeout(
      () =>
        subscribeWsForEventOdds(
          urlTopic,
          sportId,
          competitionId,
          eventId,
          marketId,
          providerId,
          isMultiMarket
        ),
      1000
    );
  }
};

export const subscribeWsForFancyMarkets = (url: string, eventId: string) => {
  if (store.getState().exchangeSports.dreamWSConnected) {
    let fmUrl = `${url}/${eventId}`;

    if (wsFancyMarketSubscritions[eventId] === undefined) {
      wsFancyMarketSubscritions[eventId] = dreamClient.subscribe(
        fmUrl,
        function (message) {
          try {
            const msgObj = JSON.parse(message.body);
            dreamLastMsgTime = moment.now();
            if (eventId) {
              const fancyMarketsPayload = {
                eventId: eventId,
                fancyUpdateData: msgObj,
              };
              // store.dispatch(updateSecondaryMarkets(secMarketsPayload));
              store.dispatch(updateFancyMarkets(fancyMarketsPayload));
            }
          } catch (e) {
            console.error('Failed to update fancy odds ', e);
          }
        }
      );
      // console.log(wsFancyMarketSubscritions[eventId]);
    }
  } else {
    setTimeout(() => subscribeWsForFancyMarkets(url, eventId), 1000);
  }
};

export const subscribeWsForSecondaryMarkets = (
  url: string,
  eventId: string,
  marketId?: string,
  sportId?: string,
  competitionId?: string,
  isMultiMarket?: boolean
) => {
  if (store.getState().exchangeSports.dreamWSConnected) {
    let bmUrl = url.includes('dream')
      ? `${url}/${eventId}/${marketId}`
      : `${url}/${eventId}`;
    if (wsSecMarketSubscritions[eventId + '-' + marketId] === undefined) {
      wsSecMarketSubscritions[eventId + '-' + marketId] = dreamClient.subscribe(
        bmUrl,
        function (message) {
          try {
            const msgObj = JSON.parse(message.body);
            // const eventId = msgObj.eventId;
            const bookmakers = msgObj;
            dreamLastMsgTime = moment.now();
            if (eventId) {
              const secMarketsPayload = {
                eventId: eventId,
                bookmakerOddsData: bookmakers ? bookmakers : [],
                enableBookmaker: true,
              };
              store.dispatch(updateSecondaryMarkets(secMarketsPayload));

            }
          } catch (e) {
            console.error('Failed to update bm odds ', e);
          }
        }
      );
    }
  } else {
    setTimeout(
      () =>
        subscribeWsForSecondaryMarkets(
          url,
          eventId,
          marketId,
          sportId,
          competitionId,
          isMultiMarket
        ),
      1000
    );
  }
};

export const subscribeWsForSecondaryMatchOdds = (
  urlTopic: string,
  eventId: string,
  marketId: string,
  providerId: string,
  sportId?: string,
  competitionId?: string,
  isMultiMarket?: boolean
) => {
  if (store.getState().exchangeSports.betFairWSConnected) {
    console.log('bf subscribed ' + urlTopic);
    if (wsSecMatchOddsSubscritions[eventId + '-' + marketId] === undefined) {
      wsSecMatchOddsSubscritions[eventId + '-' + marketId] =
        stompClient.subscribe(
          `${urlTopic}/${eventId}/${marketId}`,
          function (message) {
            const msgObj = JSON.parse(message.body);
            const msgBody = {
              eventId: msgObj.eventId,
              matchOdds: {
                marketId: msgObj.marketId,
                marketTime: msgObj.marketTime,
                marketName: msgObj.marketName,
                status: msgObj.status,
                runners: msgObj.runners,
              },
            };
            const eventId = msgObj.eventId;
            bfLastMsgTime = moment.now();
            if (eventId) {
              const secMatchOddsPayload = {
                eventId: eventId,
                marketId: msgBody.matchOdds?.marketId,
                matchOddsData: msgBody.matchOdds ? msgBody.matchOdds : null,
              };
              store.dispatch(updateSecondaryMatchOdds(secMatchOddsPayload));
            }
          }
        );
    }
  }
};

export const subscribeWsForBinaryMarkets = () => {
  if (stompClient !== null && stompClient.connected) {
    if (Object.keys(wsSecBinarySubscrition).length === 0) {
      wsSecBinarySubscrition['BINARYWS'] = stompClient.subscribe(
        `/topic/binary_odds_update`,
        function (message) {
          const msgObj = JSON.parse(message.body);
          if (msgObj) {
            store.dispatch(updateBinaryMarkets(msgObj));
          }
        }
      );
    }
  } else {
    setTimeout(() => subscribeWsForBinaryMarkets(), 1000);
  }
};

export const unsubscribeAllWsforEvents = () => {
  if (stompClient !== null && stompClient.connected) {
    for (const wsEvent of Object.keys(wsSubscriptions)) {
      wsSubscriptions[wsEvent].unsubscribe();
      // console.log('unsubscribed ' + wsEvent);
      delete wsSubscriptions[wsEvent];
    }
    for (const wsEvent of Object.keys(wsSecMarketSubscritions)) {
      wsSecMarketSubscritions[wsEvent].unsubscribe();
      console.log('unsubscribed ' + wsEvent);
      delete wsSecMarketSubscritions[wsEvent];
    }
    for (const wsEvent of Object.keys(wsSecMatchOddsSubscritions)) {
      wsSecMatchOddsSubscritions[wsEvent].unsubscribe();
      console.log('unsubscribed ' + wsEvent);
      delete wsSecMatchOddsSubscritions[wsEvent];
    }
    for (const wsEvent of Object.keys(wsInCasinoSubscriptions)) {
      wsInCasinoSubscriptions[wsEvent].unsubscribe();
      console.log('unsubscribed ' + wsEvent);
      delete wsSecMatchOddsSubscritions[wsEvent];
    }

    for (const wsEvent of Object.keys(wsScorecardSubscriptions)) {
      wsScorecardSubscriptions[wsEvent].unsubscribe();
      console.log('unsubscribed ' + wsEvent);
      delete wsScorecardSubscriptions[wsEvent];
    }
    wsSecMarketSubscritions = {};
    wsSubscriptions = {};
    wsSecMatchOddsSubscritions = {};
    wsScorecardSubscriptions = {};
  }
};

export const unsubscribeWsforBinaryEvent = () => {
  if (stompClient !== null && stompClient.connected) {
    // if (wsSecBinarySubscrition) {
    wsSecBinarySubscrition['BINARYWS'].unsubscribe();
    wsSecBinarySubscrition = undefined;
    // }
  }
};

export const unsubscribeWsforEvent = (wsEvent: string) => {
  if (stompClient !== null && stompClient.connected) {
    wsSubscriptions[wsEvent].unsubscribe();
    wsSecMarketSubscritions[wsEvent].unsubscribe();
    delete wsSubscriptions[wsEvent];
    delete wsSecMarketSubscritions[wsEvent];
    console.log('unsubscribed ' + wsEvent);
  }
};

export const disconnectToWS = () => {
  if (stompClient !== null) {
    unsubscribeAllWsforEvents();
  }
};

// Casino sockets
export const subscribeWsForIndianCasino = (gameCode: string) => {
  if (stompClient !== null && stompClient.connected) {
    if (wsInCasinoSubscriptions[gameCode + '-round'] === undefined) {
      wsInCasinoSubscriptions[gameCode + '-round'] = stompClient.subscribe(
        `/topic/indian_casino_round/${gameCode}`,
        function (message) {
          const msgObj = JSON.parse(message.body);
          store.dispatch(updateGameData(msgObj));
        }
      );
      // console.log(wsInCasinoSubscriptions[gameCode + '-round']);
    }
  } else {
    setTimeout(() => subscribeWsForIndianCasino(gameCode), 1000);
  }
};

export const subscribeWsForIndianCasinoGameResult = (gameCode: string) => {
  if (stompClient !== null && stompClient.connected) {
    if (wsInCasinoSubscriptions[gameCode + '-result'] === undefined) {
      wsInCasinoSubscriptions[gameCode + '-result'] = stompClient.subscribe(
        `/topic/indian_casino_result/${gameCode}`,
        function (message) {
          const msgObj = JSON.parse(message.body);
          store.dispatch(updateGameResults(msgObj.icResultsData));
        }
      );
      // console.log(wsInCasinoSubscriptions[gameCode + '-result']);
    }
  } else {
    setTimeout(() => subscribeWsForIndianCasinoGameResult(gameCode), 1000);
  }
};

// Socrecard
export const subscribeScorecard = (sportId: string, eventId: string) => {
  let topicUrl = `/topic/score_card_update_json_data/${eventId}`;
  if (sportId.toString() === '4') {
    topicUrl = `/topic/score_card_update/${eventId}`;
  }
  if (stompClient !== null && stompClient.connected) {
    if (wsScorecardSubscriptions[sportId + '-' + eventId] === undefined) {
      wsScorecardSubscriptions[sportId + '-' + eventId] = stompClient.subscribe(
        topicUrl,
        function (message) {
          const msgObj = JSON.parse(message.body);
          // const msgBody = msgObj.data;
          if (eventId) {
            store.dispatch(updateEventScorecard(msgObj));
            // console.log(msgObj);
          }
        }
      );
      // console.log(wsSecMatchOddsSubscritions[sportId + '-' + eventId]);
    }
  } else {
    setTimeout(() => subscribeScorecard(sportId, eventId), 1000);
  }
};
